import api from '~/services/api';

function obterModulosBusca() {
  return api.get('BuscaDocumento/modulos');
}

function buscarDocumentos(dto) {
  return api.post('BuscaDocumento/busca', dto);
}

export { obterModulosBusca, buscarDocumentos };
